import { Box, Stack, Typography, useTheme } from "@mui/material";
import FooterLayout from "../footer/footerLayout";
import NavigationLayout from "../navigation/navigationLayout";
import TitleComponent from "../../components/widgets/titleComponent";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import companyData from '../../assets/data/company.json';
import { Link } from "react-router-dom";
import { transform } from "framer-motion";

const PolicyLayout = ({
    data
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <Box
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default,
                    pt: {xs: 15, md: 20, lg: 25},
                    pb: {xs: 10, md: 20}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={data.title}
                        description={data.updated}
                        centerMode
                    />

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='center'
                        width='100%'
                        spacing={{xs: 3, md: 7}}
                    >
                        {
                            data.content.map((item, index) => {
                                return <PolicyBody 
                                    key={index}
                                    title={item.title}
                                    description={item.description}
                                />
                            })
                        }
                    </Stack>

                    <Stack
                        direction='column'
                        justifyContent='start'
                        alignItems='start'
                        width='100%'
                        pt={{xs: 2, md: 4}}
                        spacing={{xs: 0, md: 0.5}}
                    >
                        <Typography
                            fontWeight={600}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('company')}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {`${t('footer.location.sri_lanka.add_line_1')} ${t('footer.location.sri_lanka.add_line_2')} ${t('footer.location.sri_lanka.add_line_3')} ${t('footer.location.sri_lanka.city')}, ${t('footer.location.sri_lanka.country')}`}
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('contact.info.email')}:<span style={{paddingRight: '5px'}}></span>
                            <Link
                                to={`mailto:${companyData.contact.email}`}
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.contact.email}
                            </Link>
                        </Typography>

                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 12, md: 12, lg: 14}}
                            textAlign="justify"
                            lineHeight={1.5}
                            color={theme.palette.text.secondary}
                        >
                            {t('contact.info.phone')}:<span style={{paddingRight: '5px'}}></span>
                            <Link
                                to={companyData.contact.whatsapp_link}
                                target="_blank"
                                style={{
                                    textDecoration: 'none',
                                    color: theme.palette.text.secondary
                                }}
                            >
                                {companyData.contact.phone}
                            </Link>
                        </Typography>
                    </Stack>
                </Stack>
            </Box>

            <FooterLayout />
        </>
    );
}

export default PolicyLayout;

const PolicyBody = ({
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignItems='start'
                width='100%'
                spacing={{xs: 1.5, md: 3}}
            >  
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='left'
                    color={theme.palette.text.primary}
                    lineHeight={1.5}
                >
                    {title}
                </Typography>

                <Typography
                    fontWeight={500}
                    fontSize={{xs: 12, md: 12, lg: 14}}
                    textAlign="justify"
                    lineHeight={1.5}
                    color={theme.palette.text.secondary}
                >
                    {description}
                </Typography>
            </Stack>
        </>
    );
}